import React, {useState, Fragment, useRef, useEffect} from 'react';
import {Dialog, Transition} from '@headlessui/react';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import SelectModal from '../../../../Selects/SelectModal';

function AcessoriosExtraModal({back, value, setValue, artigos, setAcessoriosExtra = () => {}, acessoriosExtra, Getartigos, aluguer, artigosExtras, setSearchExtra, searchExtra}) {
    const cancelButtonRef = useRef(null);
    const {t} = useTranslation();
    // const [rows, setRows] = useState([{ isAdding: true }]);
    const [acessoriosExtrasSelecionados, setAcessoriosExtrasSelecionados] = useState(acessoriosExtra);
    const [referenceInput, setReferenceInput] = useState('');
    const [valueInput, setValueInput] = useState('');
    const [filtroDescricao, setFiltroDescricao] = useState('');
    const [filtroRef, setFiltroRef] = useState('');

    function Guardar() {
        debugger;
        const acessoriosFinais = acessoriosExtrasSelecionados
            .filter(linha => linha.referencia !== '')
            .map(a => {
                return {...a, quantidade: 1, desconto: 0, iva: 0, ecovalor: 0, referencia: a.value, descricao: a.label};
            });
        setAcessoriosExtra(acessoriosFinais);
    }

    function handleInputChange(e, index) {
        var a = acessoriosExtrasSelecionados.find(ace => ace.value === e.value);
        if (!a) {
            setAcessoriosExtrasSelecionados([...acessoriosExtrasSelecionados, e]);
        } else {
            setAcessoriosExtrasSelecionados(acessoriosExtrasSelecionados.map(ace => (ace.value === e.value ? e : ace)));
        }
    }

    const handleCheckboxChange = item => {
        if (acessoriosExtrasSelecionados?.find(element => element.value == item.value) != null) {
            setAcessoriosExtrasSelecionados(acessoriosExtrasSelecionados?.filter(selected => selected.value != item.value));
        } else {
            setAcessoriosExtrasSelecionados([...acessoriosExtrasSelecionados, item]);
        }
    };

    return (
        <Transition.Root show as={Fragment}>
            <Dialog
                as="div"
                className="relative z-40  "
                initialFocus={cancelButtonRef}
                onClose={() => {
                    back();
                }}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className={`fixed inset-0 z-10 overflow-y-auto ${window.innerWidth <= 1023 && window.innerWidth >= 640 ? 'p-8' : ''} mb-20`}>
                    <div className="flex min-h-full  items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-[900px] sm:max-h-[600px]">
                                <div className="flex items-start justify-between px-4 py-2 border-b rounded-t bg-gray-50 border-gray-100">
                                    <h3 className="text-xl mt-2 font-semibold text-gray-600 ">{t('extras')}</h3>
                                    <button
                                        type="button"
                                        className="inline-flex justify-end rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            back();
                                        }}>
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div>
                                    <div className="overflow-x-auto">
                                        <div className="table-wrp block max-h-96 relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                                            <table className=" overflow-y-auto w-full text-sm text-left text-gray-500 ">
                                                <thead className=" sticky top-0 z-20  text-xs text-gray-700 uppercase bg-gray-100 ">
                                                    <tr>
                                                        <th scope="col" className="px-2 py-3"></th>
                                                        <th scope="col" colSpan={2} className="px-12 py-3">
                                                            <div className="relative">
                                                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                                    <svg
                                                                        className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                        aria-hidden="true"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        fill="none"
                                                                        viewBox="0 0 20 20">
                                                                        <path
                                                                            stroke="currentColor"
                                                                            stroke-linecap="round"
                                                                            stroke-linejoin="round"
                                                                            stroke-width="2"
                                                                            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                                                        />
                                                                    </svg>
                                                                </div>
                                                                <input
                                                                    type="search"
                                                                    id="default-search"
                                                                    value={filtroRef}
                                                                    className="block w-full p-2 pl-10 text-xs text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
                                                                    placeholder={t('filtro')}
                                                                    onChange={e => {
                                                                        setSearchExtra(e.target.value);
                                                                        setFiltroRef(e.target.value);
                                                                    }}
                                                                />
                                                            </div>
                                                        </th>
                                                        <th scope="col" className="px-2 py-3"></th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" className="px-2 py-3"></th>
                                                        <th scope="col" className="px-12 py-3 xs:px-2">
                                                            {t('referencia')}
                                                        </th>
                                                        <th scope="col" className="px-2 py-3">
                                                            {t('descricao')}
                                                        </th>
                                                        {!aluguer && (
                                                            <th scope="col" className="px-2 py-3 xs:px-12">
                                                                {t('valor')}
                                                            </th>
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody className=" max-h-200">
                                                    {(searchExtra || acessoriosExtrasSelecionados.length == 0 ? artigosExtras : [...acessoriosExtrasSelecionados])?.map((item, rowIndex) => (
                                                        <tr className="odd:bg-white border-b cursor-pointer even:bg-gray-50  hover:bg-gray-50 ">
                                                            <td className="px-6 py-1">
                                                                <label className="relative inline-flex items-center cursor-pointer">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={item.value}
                                                                        value=""
                                                                        checked={!!acessoriosExtrasSelecionados?.find(el => el.value === item.value)}
                                                                        onChange={e => {
                                                                            e.stopPropagation();
                                                                            handleCheckboxChange(item);
                                                                        }}
                                                                        // onClick={addAcessorioExtra}
                                                                        className="sr-only peer"
                                                                    />
                                                                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300  rounded-full peer  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600"></div>
                                                                </label>
                                                            </td>

                                                            <td
                                                                className="px-12 py-1 xs:px-2 text-blue-600 "
                                                                onClick={() => {
                                                                    handleCheckboxChange(item);
                                                                }}>
                                                                {item.value}
                                                            </td>
                                                            <td
                                                                className="px-2 py-1 text-blue-600 "
                                                                onClick={() => {
                                                                    handleCheckboxChange(item);
                                                                }}>
                                                                {item.label}
                                                            </td>
                                                            {!aluguer && (
                                                                <td className="px-2 xs:px-4 py-1 text-blue-600 ">
                                                                    <input
                                                                        type="number"
                                                                        name="price"
                                                                        id="price"
                                                                        value={item?.preco || ""}
                                                                        placeholder="0"
                                                                        min={0}
                                                                        className="block sm:w-52 xs:w-32 text-xs  rounded-[8px] border-0 py-1.5 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                                     
                                                                        onChange={e => {
                                                                            if (Number(e.target.value) < 0) item.preco = 0;
                                                                            else item.preco = Number(e.target.value);

                                                                            handleInputChange(item, rowIndex);
                                                                        }}
                                                                    />
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {/* {semDados && !loading && <NotFound frase={t('semRegistos')} />} */}
                                        </div>
                                        {/* )} */}
                                    </div>

                                    <div className="flex flex-row justify-end p-2">
                                        <button
                                            type="button"
                                            className="inline-flex w-full  justify-center rounded-[4px] text-white bg-blue-500 px-2 py-1 text-sm font-semibold  shadow-sm hover:bg-blue-600 sm:ml-3 sm:w-auto"
                                            onClick={() => {
                                                Guardar();
                                                back();
                                                //   setShowForm(false);
                                                //   setOpen(false);
                                            }}>
                                            {t('guardar')}
                                        </button>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default AcessoriosExtraModal;
